import React from 'react';

import {
  PanelResizeHandle as RPPanelResizeHandle,
  PanelResizeHandleProps as RPPanelResizeHandleProps,
} from 'react-resizable-panels';

import cn from '~/utils/cn';

export interface ResizeableHandleProps extends Omit<RPPanelResizeHandleProps, 'className'> {
  className?: string;
  children?: React.ReactNode;
}

export const ResizeableHandle: React.FC<ResizeableHandleProps> = ({ className = '', children, ...rest }) => {
  return (
    <RPPanelResizeHandle
      role="separator"
      aria-orientation="horizontal"
      aria-label="Resize handle"
      className={cn(
        'flex w-2 cursor-col-resize items-center justify-center bg-slate-900/5 transition-colors hover:bg-slate-900/10',
        className
      )}
      {...rest}
    >
      {children}
    </RPPanelResizeHandle>
  );
};

export default ResizeableHandle;
